<template>
  <v-flex class="transferFunds fill-height" data-qa="localpayments-flex-gcij6">
    <Loader v-show="showLoader"/>
    <ConfirmExit
      v-if="isLeavingRoute"
      v-on:isLeavingRoute="proceedLeave"
      v-on:isNotLeavingRoute="cancelLeave"
    />
    <v-flex v-if="!reviewScreen" xs12 sm12 md12 lg12 xl12 data-qa="localpayments-flex-m721kb">
      <v-navigation-drawer
      :value="openPayee"
      :width="360"
      :close-on-click="true"
      absolute
      bottom
      right
      floating
      class="transferFunds--payeeList"
     data-qa="localpayments-navigation-drawer-4z31wi">
      <v-card height="100%" data-qa="localpayments-card-ui5e8o">
        <template v-if="!enablePayeeForm">
          <v-toolbar color="white" light data-qa="localpayments-toolbar-yttsnt">
            <v-toolbar-title data-qa="localpayments-toolbar-title-16nlij">
              <v-list-item-title
                class="text-h6"
               data-qa="localpayments-list-item-title-pcokj8"> {{ $t("localPayments.label.selectPayee") }}
              </v-list-item-title>
            </v-toolbar-title>
            <v-spacer data-qa="localpayments-spacer-op1oim"></v-spacer>
            <v-btn @click.stop="toggleDrawer()" icon data-qa="localpayments-btn-oce81m">
              <v-icon class="material-symbols-outlined" data-qa="localpayments-icon-gkapf2">close</v-icon>
            </v-btn>
          </v-toolbar>
        <v-divider data-qa="localpayments-divider-9c0gnl"  />
        </template>
        <!-- Search Payee -->
        <v-list-item
          v-if="!enablePayeeForm"
          two-line
         data-qa="localpayments-list-item-9fa9e">
          <v-list-item-content data-qa="localpayments-list-item-content-ir5pqp">
            <v-list-item-title data-qa="localpayments-list-item-title-1az13">
              <v-text-field
                v-model="searchPayee"
                :label="$t('localPayments.label.payeeSearchLabel')"
                :color="primaryColor"
                prepend-inner-icon="mdi-magnify"
                class="transferFunds--custom-textfield"
                clearable
                filled
               data-qa="localpayments-text-field-unlxzj"></v-text-field>
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <!-- Payee list -->
        <v-list
          v-if="!enablePayeeForm"
          two-line
          flat
          class="mt-n8"
         data-qa="localpayments-list-rp5r33">
          <v-row no-gutters justify="end" class="px-3" v-if="enableAddNewPayee" data-qa="localpayments-row-qkprzt">
            <v-btn
              @click="enablePayeeForm = true"
              :color="primaryColor"
              dark
              class="text-capitalize"
             data-qa="localpayments-btn-2we9n">
              {{ $t("domesticPayments.addPayeeBtn") }}
            </v-btn>
          </v-row>
          <v-flex class="mx-5 py-4" v-if="enablePayeeFilter" data-qa="localpayments-flex-tnc997">
            <v-tabs
              :color="primaryColor"
              v-model="showAccounts"
              class="text-capitalize"
             data-qa="localpayments-tabs-aad6zx">
              <v-tab class="text-none font-weight-bold" data-qa="localpayments-tab-0dag1">
                {{ $t("payee.linkedAccBtn") }}
              </v-tab>
              <v-tab class="text-none font-weight-bold" data-qa="localpayments-tab-cdcuj">
                {{ $t("payee.payeeBtn") }}
              </v-tab>
            </v-tabs>
          </v-flex>
          <template v-if="filteredPayees.length">
            <div
              v-for="(item, index) in filteredPayees"
              :key="item.accountIdentification"
             :data-qa="`localpayments-div-goqti-${index}`">
              <v-list-item @click="handleSelectedPayee(item)" :data-qa="`localpayments-list-item-5ozuxq-${index}`">
                <v-list-item-content :data-qa="`localpayments-list-item-content-meb3z-${index}`">
                  <v-list-item-title :data-qa="`localpayments-list-item-title-4glfm2-${index}`"
                    v-text="item.beneficiaryName"
                    class="text--primary"
                  />
                  <v-list-item-subtitle :data-qa="`localpayments-list-item-subtitle-3bzqut-${index}`"
                    v-text="item.accountIdentification"
                  />
                  <v-list-item-subtitle :data-qa="`localpayments-list-item-subtitle-jsjz1q-${index}`"
                    v-text="`${item.bankIdentifier} (BIC Code)`"
                  />
                </v-list-item-content>
              </v-list-item>
              <v-divider
                v-if="showDivider(index, beneficiaryList)"
                :key="index"
                :data-qa="`localpayments-divider-fd4iv-${index}`"></v-divider>
            </div>
          </template>
          <v-row v-else no-gutters justify="center" class="pa-2" data-qa="localpayments-row-rpu53r">
            {{ $t('payee.notAvailable')}}
          </v-row>
        </v-list>
        <template v-if="enablePayeeForm">
          <v-toolbar color="white" light data-qa="localpayments-toolbar-m1v6to">
            <v-toolbar-title data-qa="localpayments-toolbar-title-3rt26">
              <v-list-item-title class="text-h6" data-qa="localpayments-list-item-title-0b3skm">
                {{ t.addPayeeHeading }}
              </v-list-item-title>
              <v-list-item-subtitle v-if="enableSearchForm" data-qa="localpayments-list-item-subtitle-mp23p8">
                <font :color="darkColor">
                  {{ t.addPayeeSubtitle }}
                </font>
              </v-list-item-subtitle>
            </v-toolbar-title>
            <v-spacer data-qa="localpayments-spacer-ah6zxh"  />
            <v-btn icon
              @click.stop="enableSearchForm ? closeSearchForm() : onCloseAddPayee()"
             data-qa="localpayments-btn-9urk1e">
              <v-icon class="material-symbols-outlined" data-qa="localpayments-icon-jsyj6j">close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-divider data-qa="localpayments-divider-6u2ku5"  />
          <v-container v-if="enableSearchForm" data-qa="localpayments-container-czhnvb">
            <v-list data-qa="localpayments-list-ai65bg">
              <v-alert icon="mdi-information-outline" class="v-alert--info" data-qa="localpayments-alert-xttkes">
                <font class="caption font-weight-regular">
                  {{ t.alertLabel }}
                </font>
              </v-alert>
              <v-text-field
                v-if="enableBankName"
                v-model="searchForm.bankName"
                :label="$t('localPayments.label.bankName', { minLength: this.minBankNameLength })"
                :color="primaryColor"
                filled
                :rules="[rules.minLength(searchForm.bankName, minBankNameLength)]"
                class="transferFunds--custom-textfield" data-qa="localpayments-text-field-qhxquj">
              </v-text-field>
              <v-text-field
                v-if="enableBankBranch"
                v-model="searchForm.branchName"
                :label="$t('localPayments.label.branchName', { minLength: this.minBankBranchLength })"
                :color="primaryColor"
                filled
                :rules="[rules.minLength(searchForm.branchName, minBankBranchLength)]"
                class="transferFunds--custom-textfield" data-qa="localpayments-text-field-aqqdvf">
              </v-text-field>
              <v-text-field
                v-if="enableBankIdentifier"
                v-model="searchForm.bankIdentifier"
                :label="$t('localPayments.label.bankIdentifier')"
                :color="primaryColor"
                filled
                class="transferFunds--custom-textfield" data-qa="localpayments-text-field-r3ks">
              </v-text-field>
              <v-row no-gutters justify="start" class="pa-2" data-qa="localpayments-row-yfy8w4">
                <v-btn
                  @click="onSearchBank"
                  :color="primaryColor"
                  :disabled="isSearchDataValid()"
                  class="white--text text-capitalize"
                 data-qa="localpayments-btn-ewm169">
                  {{ $t("domesticPayments.searchBtn") }}
                </v-btn>
              </v-row>
              <font v-if="bankList.length" class="pl-4 text-h6 font-weight-light">
                {{ $t("domesticPayments.searchResultsTitle") }}
              </font>
              <div v-if="bankList.length" data-qa="localpayments-div-ta6ix">
                <template v-for="(data, index) in bankList">
                  <v-list-item :key="data.nationalIdentifier || data.bankIdentifier" :data-qa="`localpayments-list-item-dotisl-${index}`">
                    <v-list-item-content :data-qa="`localpayments-list-item-content-hrroxb-${index}`">
                      <v-flex xs8 sm8 md8 lg8 xl8 :data-qa="`localpayments-flex-15lp6-${index}`">
                        <v-list-item-title :data-qa="`localpayments-list-item-title-p4liou-${index}`">
                          <font class="body-2 font-weight-light">
                            {{ convertToCapitalisedSentence(data.bankName) }}
                          </font>
                        </v-list-item-title>
                        <v-list-item-subtitle :data-qa="`localpayments-list-item-subtitle-e0rxt-${index}`">
                          <font class="body-2 font-weight-light">
                            {{ convertToCapitalisedSentence(data.branchName) || data.otherInfo }}
                          </font>
                        </v-list-item-subtitle>
                        <v-list-item-subtitle :data-qa="`localpayments-list-item-subtitle-4dx10d-${index}`">
                          <font class="body-2 font-weight-light">
                            {{ convertToCapitalisedSentence(data.city) }}
                          </font>
                        </v-list-item-subtitle>
                        <v-list-item-subtitle v-if="enableBankAddress" :data-qa="`localpayments-list-item-subtitle-smf5u-${index}`">
                          <font class="body-2 font-weight-light">
                            {{ convertToCapitalisedSentence(data.address) }}
                          </font>
                        </v-list-item-subtitle>
                        <v-list-item-subtitle v-if="enableBankIdSearchResult" :data-qa="`localpayments-list-item-subtitle-r3kkco-${index}`">
                          <font class="caption font-weight-bold">
                            {{ $t("localPayments.label.bankIdLabel") }}
                          </font>
                          <font class="caption font-weight-bold">
                            {{ data.bankIdentifier }}
                          </font>
                        </v-list-item-subtitle>
                      </v-flex>
                      <v-flex xs4 sm4 md4 lg4 xl4 class="text-end" :data-qa="`localpayments-flex-81yfhu-${index}`">
                        <v-btn
                          @click="onBankSelect(data)"
                          :color="primaryColor"
                          class="text-none"
                          :data-qa="`localpayments-btn-b3r73l-${index}`">
                          {{ $t("localPayments.buttons.selectBtn") }}
                        </v-btn>
                      </v-flex>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider v-if="showDivider(index, bankList)" :key="index" :data-qa="`localpayments-divider-3chlt-${index}`">
                  </v-divider>
                </template>
              </div>
              <div v-if="!searchForm.isSearchAvailable && !bankList.length"
               data-qa="localpayments-div-mwowc">
                <font class="pl-4 text-h6 font-weight-light">
                  {{ $t("localPayments.label.searchResultsTitle") }}
                </font>
                <v-list-item data-qa="localpayments-list-item-5knn1">
                  <font class="body-2 font-weight-light">
                    {{ $t("localPayments.label.noBanks") }}
                  </font>
                </v-list-item>
              </div>
            </v-list>
          </v-container>
          <v-container v-if="!enableSearchForm" data-qa="localpayments-container-b8vaup">
            <v-form
              ref="payeeForm"
              v-model="isPayeeFormValid"
             data-qa="localpayments-form-vkrynn">
              <v-text-field
                v-model="payeeForm.firstName"
                :label="$t('domesticPayments.payeeFirstName')"
                :color="primaryColor"
                :rules="[rules.firstNameLastName]"
                :maxlength="payeeForm.payeeNameMaxLen ? payeeForm.payeeNameMaxLen : false"
                filled
                class="transferFunds--custom-textfield"
               data-qa="localpayments-text-field-oz3qfk">
              </v-text-field>
              <v-text-field
                v-model="payeeForm.lastName"
                :label="$t('domesticPayments.payeeLastName')"
                :color="primaryColor"
                :rules="[rules.firstNameLastName]"
                :maxlength="payeeForm.payeeNameMaxLen ? payeeForm.payeeNameMaxLen : false"
                filled
                class="transferFunds--custom-textfield"
               data-qa="localpayments-text-field-ej3jyb">
              </v-text-field>
              <v-text-field
                v-model="payeeForm.toAccountBIC"
                v-if="route.bankIdentifier === 'BIC'"
                :label="$t('internationalPayments.payeeAccNoLabel')"
                :color="primaryColor"
                :rules="[rules.requiredRule]"
                filled
                required
                :type="enableMaskedAccountNumber ? 'password' : 'text'"
                onCopy="return false"
                onpaste="return false"
                class="transferFunds--custom-textfield"
                @keydown="$formatter.validateNumberInput($event, getIBAN())"
               data-qa="localpayments-text-field-trtsrl">
              </v-text-field>
              <v-text-field
                v-model="payeeForm.toAccountProp"
                v-if="route.bankIdentifier === 'PROPRIETARY'"
                :label="$t('domesticPayments.payeeAccNoLabel')"
                :color="primaryColor"
                :rules="[rules.proprietaryAccountFormat, rules.requiredRule]"
                :maxlength="proprietaryAccountMaxLength"
                filled
                required
                :type="enableMaskedAccountNumber ? 'password' : 'text'"
                onCopy="return false"
                onpaste="return false"
                class="transferFunds--custom-textfield"
               data-qa="localpayments-text-field-lwd73y">
              </v-text-field>
              <v-text-field
                v-model="payeeForm.bicCode"
                v-if="route.bankIdentifier === 'BIC'"
                :label="$t('localPayments.label.bicCodeLabel')"
                :color="primaryColor"
                :rules="[rules.requiredRule]"
                filled
                required
                class="transferFunds--custom-textfield"
               data-qa="localpayments-text-field-4ojeog">
              </v-text-field>
              <v-select
                v-if="route.bankIdentifier === 'PROPRIETARY'"
                v-model="selectedCountryCode"
                :label="this.$t('localPayments.label.country')"
                :items="listCountryCodes"
                autocomplete
                :rules="[rules.requiredRule]"
                max-height="auto"
                filled
                item-text="codeDescription"
                item-value="codeReference"
                :color="primaryColor"
                class="transferFunds--custom-textfield"
               data-qa="localpayments-select-zffxtr"></v-select>
              <v-layout class="pa-0" v-if="route.bankIdentifier === 'PROPRIETARY' && enableBankSearch" data-qa="localpayments-layout-gdg9cj">
                <v-flex xs8 sm8 md8 lg8 xl8 data-qa="localpayments-flex-bw5m2o">
                  <v-text-field
                    v-model="payeeForm.bankName"
                    :label="$t('addNewPayee.bankName')"
                    :color="primaryColor"
                    :rules="[rules.requiredRule]"
                    readonly
                    class="transferfunds--nonEditable-textfield" data-qa="localpayments-text-field-gupiic">
                  </v-text-field>
                </v-flex>
                <v-flex xs4 sm4 md4 lg4 xl4
                  class="text-end"
                 data-qa="localpayments-flex-dmfzwf">
                  <v-btn
                    @click="showSearchForm()"
                    outlined
                    :color="primaryColor"
                    class="text-none subtitle-2 font-weight-regular"
                   data-qa="localpayments-btn-ttngf5">
                    <v-icon class="material-symbols-outlined" data-qa="localpayments-icon-nq6nto">search</v-icon>
                    {{ $t("domesticPayments.searchSortCodeBtn") }}
                  </v-btn>
                </v-flex>
              </v-layout>
              <v-flex class="px-3 font-weight-bold" xs12 sm12 md12 lg12 xl12 data-qa="localpayments-flex-xlr4j8">
                {{$t('addNewPayee.whoseBankAccount')}}
                <v-radio-group
                  v-model="isOwnAccLinked"
                  :rules="[fieldRules]"
                  row
                  class="font-weight-regular"
                 data-qa="localpayments-radio-group-lbayth">
                  <v-radio
                    :label="$t('addNewPayee.ownAccount')"
                    value="own"
                    :color="secondaryColor"
                   data-qa="localpayments-radio-3j2yyp">
                  </v-radio>
                  <v-radio
                    :label="$t('addNewPayee.othersAccount')"
                    value="others"
                    :color="secondaryColor"
                   data-qa="localpayments-radio-e8jlb5">
                  </v-radio>
                  </v-radio-group>
                </v-flex>
                <v-text-field
                  v-if="isOwnAccLinked === 'others'"
                  v-model="payeeForm.townName"
                  :label="$t('localPayments.label.townName')"
                  :color="primaryColor"
                  :rules="[rules.requiredRule]"
                  filled
                  required
                  class="transferFunds--custom-textfield" data-qa="localpayments-text-field-eikstf">
                </v-text-field>
                <v-text-field
                  v-if="isOwnAccLinked === 'others'"
                  v-model="payeeForm.postalCode"
                  :label="$t('localPayments.label.postalCode')"
                  :color="primaryColor"
                  :rules="[rules.requiredRule]"
                  filled
                  required
                  class="transferFunds--custom-textfield" data-qa="localpayments-text-field-c42jh">
                </v-text-field>
                <v-row no-gutters justify="start" class="pa-2" data-qa="localpayments-row-j6h24i">
                  <v-btn
                    @click="onAddPayee"
                    :color="primaryColor"
                    :disabled="!isPayeeFormValid"
                    class="white--text text-capitalize"
                   data-qa="localpayments-btn-dpiv8n">
                    {{ $t("addNewPayee.addPayeeBtn") }}
                  </v-btn>
                </v-row>
              </v-form>
            </v-container>
          </template>
        </v-card>
      </v-navigation-drawer>
      <v-flex xs12 sm12 md12 lg12 xl12 data-qa="localpayments-flex-jls9gl">
        <v-layout wrap class="ml-2 transferFunds--gradientBGposition" data-qa="localpayments-layout-m2tlh">
          <v-flex
            xs12
            sm12
            md12
            lg12
            xl12
            :style="{ background: dashboardGradient, height: '180px' }"
           data-qa="localpayments-flex-lojuy">
            <v-container class="transferFunds--title-padding" data-qa="localpayments-container-802l4">
              <v-flex xs12 sm12 md12 lg12 xl12 data-qa="localpayments-flex-fx7fe">
                <v-row no-gutters data-qa="localpayments-row-fyods">
                  <v-layout row wrap class="pb-2" data-qa="localpayments-layout-wnyhna">
                    <v-flex xs2 sm2 md2 lg1 xl1 class="pr-6 pt-4" data-qa="localpayments-flex-zy3rqo">
                      <v-row justify="end" data-qa="localpayments-row-95o49">
                        <v-avatar :tile="false" size="35" color="white" data-qa="localpayments-avatar-cjhuo4">
                          <v-icon :color="primaryColor" data-qa="localpayments-icon-d0i6ba">mdi-sync</v-icon>
                        </v-avatar>
                      </v-row>
                    </v-flex>
                    <v-flex xs9 sm9 md9 lg9 xl9 class="pt-2" data-qa="localpayments-flex-ekt8nt">
                      <v-row no-gutters data-qa="localpayments-row-zqnm9">
                        <font class="text-h5 font-weight-light white--text">
                          {{ $t("localPayments.title") }}</font
                        >
                      </v-row>
                    </v-flex>
                  </v-layout>
                </v-row>
              </v-flex>
            </v-container>
          </v-flex>
        </v-layout>
        <!-- Start Payment Transfer Form-->
        <v-flex
          xs12
          sm12
          md12
          lg10
          xl10
          class="transferFunds--content-padding transferFunds--overlayCardFlex"
         data-qa="localpayments-flex-uqx8p">
          <v-layout row wrap class="transferFunds--content-padding" data-qa="localpayments-layout-zo9ghh">
            <v-flex xs12 sm11 md10 lg10 xl10 class="pt-4" data-qa="localpayments-flex-34y7p">
              <!-- <v-form data-qa="localpayments-form-p9e5np"> -->
                <Form
                  v-if="showForm"
                  :config="formConfig"
                  :key="componentKey"
                >
                  <template v-slot:formActions>
                    <v-btn
                      :dark="!disableReviewBtn"
                      :color="primaryColor"
                      class="mb-4 ml-5 px-4 py-2 text-capitalize"
                      @click="validatePayment"
                      :disabled=disableReviewBtn
                     data-qa="localpayments-btn-e2zmal">
                      {{ $t('localPayments.label.reviewPayment') }}
                    </v-btn>
                  </template>
                </Form>
              <!-- </v-form> -->
            </v-flex>
          </v-layout>
        </v-flex>
      </v-flex>
    </v-flex>
    <v-flex v-if="reviewScreen" data-qa="localpayments-flex-njwb3s">
      <local-payments-review
        @refreshAccounts="getSourceAccountList"
        :config="{ payload, unflattenBody, charges, transactionId, fromAccDetails,
          bankIdType, accIdentification, accBICCode, beneName, beneId }"
      />
    </v-flex>
    <PaymentFailureDialog
      :show="failureDialog.show"
      :retry="false"
      :internalError="this.$route.meta.paymentError ? true : false"
      :error-list="failureDialog.errorList"
      @goBack="handleGoBack"
      @cancelTransfer="handleCancelTransfer"
      @routeToDashboard="routeToDashboard"
    />
    <!-- OTP -->
    <Modal
      v-if="enableOTPForAddPayee && showOTPScreen"
      @cancel="onOtpModalClose"
      :config="beneficiaryOtpConfig"
    >
      <span slot="modalContent" data-qa="localpayments-span-ok4lg">
        <OtpInput :otpConfig="otpSettings" />
      </span>
    </Modal>
    <LocalPaymentsAddPayeeSuccess
      :displaySuccess="displayAddPayeeSuccess"
      @closePayeeSuccess="onClosePayeeSuccess"
    />
    <LocalPaymentsAddPayeeFailure
      :displayError="displayAddPayeeError"
      :errors="addPayeeErrorList.causes"
      :retryActive="checkRetries"
      @closePayeeError="onClosePayeeError"
      @retryAddPayee="onRetryAddPayee"
    />
  </v-flex>
</template>

<script>
import _ from 'lodash'
import event from '@/util/event'
import preload from '@/util/preload'
import '@/styles/pages/login/login.scss'
import '@/styles/pages/transferFunds.scss'
import Loader from '@/components/common/Loader.vue'
import getFormConfig from '@/util/formUtility.js'
import CommonService from '@/service/commonService.js'
import LocalPaymentsReview from './LocalPaymentsReview.vue'
import { flatten, unflatten } from 'flat'
import PaymentFailureDialog from '../common/PaymentFailureDialog.vue'
import { convertToISO, createNestedObject, merge, getAccountLabel, getToday } from './LocalPaymentsUtil'
import LocalPaymentsAddPayeeSuccess from './LocalPaymentsAddPayeeSuccess.vue'
import LocalPaymentsAddPayeeFailure from './LocalPaymentsAddPayeeFailure.vue'
import smeRolesMixin from '@/core/mixins/smeRolesMixin.js'

const INPUT_BG_COLOR = '#f0eff7'

export default {
  name: 'LocalPayments',
  components: {
    Loader,
    LocalPaymentsReview,
    PaymentFailureDialog,
    LocalPaymentsAddPayeeSuccess,
    LocalPaymentsAddPayeeFailure,
    Form: () => import('@/components/DOB-Form/Form.vue'),
    ConfirmExit: () => import('@/components/common/ConfirmExit.vue'),
    Modal: () => import('@/components/common/Modal.vue'),
    OtpInput: () => import('@/components/common/OtpInput.vue')
  },
  mixins: [ smeRolesMixin ],
  data () {
    return {
      charges: '',
      bankIdType: '',
      retryCount: 1,
      displayAddPayeeSuccess: false,
      displayAddPayeeError: false,
      addPayeeErrorList: [],
      listOfAccountsBal: [],
      currency: '',
      accIdentification: '',
      accProprietary: '',
      accIBAN: '',
      accBICCode: '',
      accIdType: '',
      failureResponseAPI: '',
      fromAccs: [],
      beneName: '',
      beneId: '',
      fromAccHasVal: false,
      toAccountHasVal: false,
      unflattenBody: {},
      isLogout: false,
      isLeavingRoute: false,
      openPayee: false,
      transactionComplete: false,
      componentKey: 0,
      addPayeeRetryLimit: this.$appSettings.defaultConfigurations.localPayments.addPayeeRetryLimit,
      enableOTPForLocalPayments: this.$appSettings.defaultConfigurations.localPayments.enableOTP,
      enableIBANAccountNumberDisplay: this.$appSettings.defaultConfigurations.enableIBANAccountNumberDisplay,
      textValidationType: ['maxLength', 'pattern'],
      textPrimaryDataType: ['string'],
      selectValidationType: ['enumeration'],
      selectPrimaryDataType: ['string'],
      calendarPrimaryDataType: ['date'],
      reviewScreen: false,
      payload: {},
      schema: {
        domesticPayment: { exists: true },
        searchBankForm: { exists: true }
      },
      showForm: false,
      customerId: '',
      beneficiaryList: [],
      loadComplete: {
        accountList: false,
        payeeList: false
      },
      failureDialog: {
        show: false,
        errorList: [],
        retryCount: 0
      },
      reviewButton: {
        disabled: true
      },
      showOTPScreen: false,
      beneficiaryOtpConfig: {
        enabled: false,
        persistent: true,
        enableSave: true,
        close: true,
        saveButton: '',
        outlinedSaveBtn: false,
        title: this.$t('otp.toolBarTitle'),
        width: 400
      },
      otpSettings: {
        resetPasswordTime: this.$appSettings.defaultConfigurations
          .otpResendTimeInterval,
        flex: 'xs12 sm12 md12 lg12 xl12'
      },
      searchPayee: '',
      showAccounts: 0,
      enableSearchForm: false,
      enablePayeeForm: false,
      isOwnAccLinked: 0,
      isPayeeFormValid: false,
      bankList: [],
      listCountryCodes: [],
      selectedCountryCode: '',
      selectedBankIdentifier: '',
      addPayeeErrors: '',
      firstName: '',
      lastName: '',
      transactionId: '',
      fromAccVal: '',
      fromAccDetails: '',
      setAccFields: false,
      enableAddNewPayee: this.$appSettings.defaultConfigurations.localPayments.enableAddNewPayee,
      enablePayeeFilter: this.$appSettings.defaultConfigurations.localPayments.enablePayeeFilter,
      localPaymentsType: this.$appSettings.defaultConfigurations.localPayments.paymentType,
      enableMaskedAccountNumber: this.$appSettings.defaultConfigurations.localPayments.enableMaskAccountNumber,
      enableOTPForAddPayee: this.$appSettings.defaultConfigurations.localPayments.enableOTPForAddNewPayee,
      enableBankSearch: this.$appSettings.defaultConfigurations.localPayments.bankSearch.enableSearch,
      enableBankName: this.$appSettings.defaultConfigurations.localPayments.bankSearch.enableBankName,
      enableBankBranch: this.$appSettings.defaultConfigurations.localPayments.bankSearch.enableBankBranch,
      enableBankIdentifier: this.$appSettings.defaultConfigurations.localPayments.bankSearch.enableBankIdentifier,
      enableBankAddress: this.$appSettings.defaultConfigurations.localPayments.bankSearch.enableBankAddress,
      enableBankIdSearchResult: this.$appSettings.defaultConfigurations.localPayments.bankSearch.enableBankIdSearchResult,
      minBankNameLength: this.$appSettings.defaultConfigurations.localPayments.bankSearch.minBankNameLength,
      minBankBranchLength: this.$appSettings.defaultConfigurations.localPayments.bankSearch.minBankBranchLength,
      enableRetryLimitForAddPayee: this.$appSettings.defaultConfigurations.localPayments.enableRetryLimitForAddPayee,
      payeeAccountNameFormat: this.$appSettings.defaultConfigurations.localPayments.payeeAccFirstLastNameFormat,
      proprietaryAccountFormat: this.$appSettings.defaultConfigurations.localPayments.proprietaryAccountFormat,
      proprietaryAccountMaxLength: this.$appSettings.defaultConfigurations.localPayments.proprietaryAccountMaxLength,
      isSmeLogin: JSON.parse(sessionStorage.getItem('isSmeLogin')),
      enableRoleBasedAccess: this.$appSettings.defaultConfigurations.smeRoles.enableRoleBasedAccess,
      t: {
        addPayeeHeading: this.$t('transferfunds.addPayeeHeading'),
        addPayeeSubtitle: this.$t('localPayments.label.searchBankDetails'),
        alertLabel: this.$t('localPayments.label.alert'),
        payeeAccountNameLabel: this.$t('transferfunds.payeeAccountNameLabel'),
        payeeAccNoLabel: this.$t('transferfunds.payeeAccNoLabel'),
        payeeReEnterAccNoLabel: this.$t('transferfunds.payeeReEnterAccNoLabel'),
        errorMsgAccNumMatch: this.$t('transferfunds.errorMsgAccNumMatch'),
        confirmAddPayee: this.$t('transferfunds.confirmAddPayee')
      },
      payeeForm: {
        toAccountBIC: '',
        toAccountProp: '',
        branchName: '',
        bicCode: '',
        bankName: '',
        townName: '',
        postalCode: '',
        accountName: '',
        firstName: '',
        lastName: '',
        bankIdentifier: '',
        payeeNameMaxLen:
        this.$appSettings.defaultConfigurations.localPayments.payeeAccFirstLastNameMaxLength
      },
      searchForm: {
        bankName: '',
        branchName: '',
        bankIdentifier: '',
        isSearchAvailable: true
      },
      fieldRules: (v) => !!v || 'Required Field',
      rules: {
        requiredRule: (v) => Boolean(v) || 'Required Field',
        requiredWithNoErrRule: (v) => Boolean(v) || '',
        lengthRange: (value, min, max) =>
          (value && (value.length > min || value.length < max)) ||
          `Enter atleast ${min} characters`,
        minLength: (value, min) => (value && value.length >= min) || this.$t('errors.common.minLength', {
          minLength: min
        }),
        minValue: (v) => v >= 2 || this.$t('transferfunds.numberOfPaymentsMinValidation'),
        maxValue: (v) => v <= 10 || this.$t('transferfunds.numberOfPaymentsMaxValidation'),
        firstNameLastName: (v) => {
          const regex = new RegExp(this.payeeAccountNameFormat)
          const result = regex.test(v)
          if (result) return true
          else return this.$t('errors.common.invalidChar')
        },
        proprietaryAccountFormat: (v) => {
          const regex = new RegExp(this.proprietaryAccountFormat)
          const result = regex.test(v)
          if (result) return true
          else return this.$t('errors.common.invalidChar')
        },
        isAlphaNumericRule: (v) => {
          if (v) {
            return (
              v.match(/^([^ !@#\\$%\\^&\\*][a-zA-Z0-9]*)$/g) ||
              this.$t('errors.common.invalidInput')
            )
          } else return 'Required Field'
        },
        numberTypeCheck: (v) =>
          new RegExp('^\\d+(.\\d\\d?)?$').test(v) ||
          this.$t('errors.common.invalidInput'),
        isAccBalanceValid: (v) =>
          v && v > 0
            ? !this.isAccountBalance || this.$t('domesticPayments.fundsError')
            : new RegExp('^0*(.0*)$').test(v) || v < 0
              ? this.$t('errors.common.minAmountError')
              : false,
        isLimitValid: () =>
          this.transferAmount <= this.UKFPSpayemntTemplate.transactionLimit ||
          this.$t('domesticPayments.limitError'),
        isAmountNumber: v => this.checkIfNumber(v),
        amountCheck: (v) => this.checkAmountInput(v)
      }
    }
  },
  computed: {
    disableReviewBtn () {
      if (this.toAccountHasVal && !this.reviewButton.disabled && this.fromAccHasVal) {
        return false
      }
      return true
    },
    formConfig () {
      return {
        label: '',
        icon: '',
        name: 'DomesticPayments',
        isEnabled: true,
        toolbar: true,
        form: this.schema.domesticPayment,
        tips: this.route.paymentMethod,
        fromAccs: this.fromAccs
      }
    },
    checkRetries () {
      if (this.retryCount < this.addPayeeRetryLimit) return true
      return false
    },
    showFailed () {
      return true
    },
    showLoader () {
      // return this.loadComplete.accountList && this.loadComplete.payeeList
      return false
    },
    route () {
      return {
        currency: this.$route.meta.paymentMethod.stpCurrency,
        accountFormat: this.$route.meta.paymentMethod.accountFormatType,
        bankIdentifier: this.$route.meta.paymentMethod.bankIdentifierType,
        details: this.$route.meta.paymentMethod.details,
        paymentMethod: this.$route.meta.paymentMethod.paymentMethod
      }
    },
    filteredPayees () {
      if (this.beneficiaryList.length) {
        let temp = []
        temp = this.beneficiaryList.filter((item) => {
          return !this.enablePayeeFilter ? temp : this.showAccounts === 0 ? item.ownAccount === 'Y' : item.ownAccount === 'N'
        })
        return _.orderBy(
          temp.filter(bene => {
            if (!this.searchPayee) return temp
            return (
              bene.beneficiaryName.toLowerCase().includes(this.searchPayee.toLowerCase()) ||
              bene.accountIdentification.toLowerCase().includes(this.searchPayee.toLowerCase()) ||
              bene.bankIdentifier.toLowerCase().includes(this.searchPayee.toLowerCase())
            )
          })
        )
      } else return []
    }
  },
  methods: {
    checkIfNumber (input) {
      const result = new RegExp('^\\d+(.\\d\\d?)?$').test(input)
      if (!input) { return this.$t('errors.common.amountRequired') }
      if (!result) { return this.$t('errors.common.invalidInput') }
      return input > 0 ? true : this.$t('errors.common.minAmountError')
    },
    checkAmountInput (input) {
      let bal
      const amount = Number(input)
      const account = this.listOfAccountsBal.find(a => a.accountId === this.schema.domesticPayment.model.sourceAccount)
      if (account) {
        bal = Number(account.balance)
      }
      return amount > bal ? this.$t('internationalPayments.fundsError') : true
    },
    onAddPayee () {
      if (this.enableOTPForAddPayee) {
        this.showOTPScreen = true
        this.beneficiaryOtpConfig.enabled = true
      } else {
        this.createBene()
      }
    },
    showSearchForm () {
      this.enableSearchForm = true
      this.searchForm.isSearchAvailable = true
    },
    closeSearchForm () {
      this.enableSearchForm = false
    },
    convertToCapitalisedSentence (sentence) {
      return this.$formatter.convertCase.convertToCapitalisedSentence(sentence)
    },
    onCloseAddPayee () {
      this.enablePayeeForm = !this.enablePayeeForm
      if (this.$refs.payeeForm) {
        this.$refs.payeeForm.reset()
      }
    },
    showDivider (index, array) {
      return array.length ? index + 1 < array.length : false
    },
    isSearchDataValid () {
      if (this.searchForm.bankName || this.searchForm.branchName || this.searchForm.bankIdentifier) return false
      else return true
    },
    getIBAN () {
      if (this.payeeForm.toAccountBIC && this.payeeForm.toAccountBIC.length) {
        return `IBAN-${this.payeeForm.toAccountBIC.length}`
      }
    },
    clearBankSearchFields () {
      this.searchForm.bankName = ''
      this.searchForm.branchName = ''
      this.searchForm.bankIdentifier = ''
    },
    setCountryCode () {
      if (this.route.bankIdentifier === 'BIC') {
        return this.payeeForm.toAccountBIC.slice(0, 2)
      } else return this.selectedCountryCode
    },
    onBankSelect (data) {
      this.enableSearchForm = false

      // clear all bank search fields
      this.clearBankSearchFields()

      // fill-up payee form fields
      this.payeeForm.bankName = data.bankName
      this.payeeForm.bankIdentifier = data.bankIdentifier
    },
    async onSearchBank () {
      const payload = {
        paymentMethod: this.route.paymentMethod,
        paymentType: this.localPaymentsType,
        bankName: this.searchForm.bankName,
        branchName: this.searchForm.branchName,
        bankIdentifier: this.searchForm.bankIdentifier
      }
      const response = await CommonService.getBankIdentifierList(payload)
      if (response && !response.causes) {
        this.bankList = response
      }
      if (!response.length) {
        this.searchForm.isSearchAvailable = false
      }
    },
    async getGenericCodes () {
      const code = {
        codeReferences: [{ reference: 'ISOCountryCode2Char' }]
      }
      const response = await CommonService.getGenericCodes(code)
      if (response && response.aggregateCodes && response.aggregateCodes[0]) {
        if (response.aggregateCodes[0].codes) {
          this.listCountryCodes = response.aggregateCodes[0].codes
        }
      }
    },
    async createBene () {
      this.onOtpModalClose()
      const body = {
        customerId: JSON.parse(sessionStorage.getItem('username')),
        firstName: this.payeeForm.firstName,
        lastName: this.payeeForm.lastName,
        accountIdentificationType: this.route.accountFormat,
        accountIdentification: this.route.bankIdentifier === 'BIC' ? this.payeeForm.toAccountBIC : this.payeeForm.toAccountProp,
        ownAccount: this.isOwnAccLinked === 'own' ? 'Y' : 'N',
        country: this.setCountryCode(),
        townName: this.payeeForm.townName,
        postalCode: this.payeeForm.postalCode,
        currency: this.route.currency,
        paymentSystem: this.route.paymentMethod,
        bankIdentifier: this.route.bankIdentifier === 'BIC' ? this.payeeForm.bicCode : this.payeeForm.bankIdentifier
      }
      if (body.ownAccount === 'Y') {
        delete body.townName
        delete body.postalCode
      }
      const response = await CommonService.createPaymentBeneficiary(body)
      try {
        if (response && !response.causes) {
          this.enableSearchForm = false
          this.searchForm.isSearchAvailable = false
          this.clearBankSearchFields()
          // Refresh Existing Payee List
          this.getPayeeList()
          this.onCloseAddPayee()
          this.displayAddPayeeSuccess = true
        } else {
          this.displayAddPayeeError = true
          this.addPayeeErrorList = response
        }
      } catch (e) {
        console.log(e)
      }
    },
    onClosePayeeSuccess () {
      this.displayAddPayeeSuccess = false
    },
    onClosePayeeError () {
      this.displayAddPayeeError = false
      this.getPayeeList()
      this.onCloseAddPayee()
      this.enableSearchForm = false
      this.searchForm.isSearchAvailable = false
      this.retryCount = 0
    },
    onRetryAddPayee () {
      this.displayAddPayeeError = false
      this.retryCount++
    },
    routeToDashboard () {
      this.transactionComplete = true
      setTimeout(() => {
        this.$router.push({ path: '/home' })
      }, 600)
    },
    handleGoBack () {
      this.failureDialog.show = false
      this.failureDialog.errorList = []
    },
    handleCancelTransfer () {
      this.failureDialog.show = false
      this.$emit('refreshAccounts')
      this.reviewClear('Reset')
      this.failureDialog.errorList = []
    },
    reviewClear (type) {
      const date = this.schema.domesticPayment.model.transactionDate
      this.schema.domesticPayment.model.transactionDate = date.split('-').reverse().join('-')
      this.reviewScreen = false
      if (type === 'Reset') {
        this.showForm = false
        setTimeout(() => {
          this.resetFormFields()
        }, 100)
      }
    },
    handleErrors (errors) {
      this.failureDialog.show = true
      if (errors.length) {
        errors.forEach(error => {
          if (error.message) {
            this.failureDialog.errorList.push(error.message)
          }
        })
      } else this.failureDialog.errorList = []
    },
    filterDisplay (accounts) {
      const excludedAccountTypes = ['NACC', 'TXFR', 'TXEA', 'TXNA', 'TXSV']
      const excludedAccountStatus = ['DORMANT', 'DEACTIVATED', 'INACTIVE', 'BLOCKED', 'STOPPED', 'CLOSED']
      return accounts
        .filter(a => !excludedAccountTypes.includes(a.accountType))
        .filter(a => a.postingsRestriction !== 'DEBIT')
        .filter(a => a.currency === this.route.currency)
        .filter(a => !excludedAccountStatus.includes(a.accountStatus))
        .map(a => ({
          ...a,
          text: `${getAccountLabel(a.accountType)}  -  ${a.accountId} - (Bal ${this.$formatter.currency.format(a.balance, a.currency)} )`,
          value: a.accountId
        }))
    },
    async getPayeeList () {
      this.loadComplete.payeeList = false
      this.beneficiaryList = []
      try {
        const response = await CommonService.getPaymentBeneficiary(this.customerId)
        if (response?.length) {
          this.beneficiaryList = response?.filter(beneficiary => beneficiary.paymentSystem === this.route.paymentMethod)
        }
      } catch (e) {
        console.log(e)
      } finally {
        this.loadComplete.payeeList = true
      }
    },
    resetFormFields () {
      this.showForm = true
      this.setDefaultValues()
    },
    async getSourceAccountList () {
      this.loadComplete.accountList = false
      const listOfAccounts = await preload.getAllCASAWithBalance(this.customerId)
      const sourceAccounts = this.filterDisplay(listOfAccounts)
      listOfAccounts.forEach(acc => {
        this.listOfAccountsBal.push({
          accountId: acc.accountId,
          balance: acc.balance
        })
      })
      this.fromAccs = await this.getFilteredAccounts(sourceAccounts)
      this.loadComplete.accountList = true
    },
    nextValidate () {
      this.payload = this.schema.domesticPayment
      this.reviewScreen = true
    },
    setDbtrAccIdType () {
      let idType = {}
      let dbtrIBAN = ''
      let dbtrProprietary = ''
      this.fromAccs.forEach(acc => {
        if (acc.value === this.fromAccVal) {
          dbtrIBAN = acc.iban
          dbtrProprietary = acc.value
        }
      })
      if (this.route.accountFormat === 'IBAN') {
        idType = {
          id: {
            iban: dbtrIBAN
          }
        }
      } else {
        idType = {
          id: {
            othr: {
              id: dbtrProprietary
            }
          }
        }
      }
      return idType
    },
    setCdtrAccIdType () {
      let idType = {}
      if (this.accIdType === 'IBAN') {
        idType = {
          id: {
            iban: this.accIdentification
          }
        }
      }

      if (this.accIdType === 'PROPRIETARY') {
        idType = {
          id: {
            othr: {
              id: this.accIdentification
            }
          }
        }
      }

      return idType
    },
    async validatePayment () {
      const d = new Date()
      this.transactionId = `DOB-${this.route.currency}-${Math.floor(Date.now() / 1000)}`
      try {
        const body = {
          initiationContext: {
            targetSchemeNm: this.route.paymentMethod,
            sourceId: 'IBI',
            preCalculatedCharges: {
              amount: 0.0,
              currency: this.route.currency
            }
          },
          cstmrCdtTrfInitn: {
            grpHdr: {
              msgId: this.transactionId,
              creDtTm: d.toISOString(),
              nbOfTxs: '1'
            },
            pmtInf: [{
              pmtInfId: this.transactionId,
              pmtMtd: 'TRA',
              nbOfTxs: '1',
              pmtTpInf: {
                instrPrty: 'HIGH'
              },
              reqdExctnDt: {
                dt: '1'
              },
              dbtr: {
                id: {
                  prvtId: {
                    othr: [{
                      id: this.customerId
                    }]
                  }
                }
              },
              dbtrAcct: this.setDbtrAccIdType(),
              cdtTrfTxInf: [{
                pmtId: {
                  instrId: this.transactionId,
                  endToEndId: this.transactionId
                },
                amt: {
                  instdAmt: {
                    amt: 0,
                    ccy: this.route.currency
                  }
                },
                cdtr: {
                  nm: this.beneName
                },
                cdtrAgt: {
                  finInstnId: {
                    bicfi: this.accBICCode
                  }
                },
                cdtrAcct: this.setCdtrAccIdType()
              }]
            }]
          },
          '@xmlns': 'urn:iso:std:iso:20022:tech:xsd:pain.001.001.11'
        }

        this.unflattenBody = body

        const model = this.schema.domesticPayment.model
        const schema = this.schema.domesticPayment.schema
        if (model.transactionDate) {
          model.transactionDate = convertToISO(model.transactionDate, schema.transactionDate.format)
        }

        for (const [key, value] of Object.entries(this.schema.domesticPayment.schema)) {
          const flattenBody = flatten(this.unflattenBody)
          if (value.jsonPath) {
            const objVal = createNestedObject(value.jsonPath, model[key])
            const flattenedObject = flatten(objVal)
            const FINBody = merge(flattenedObject, flattenBody)

            this.unflattenBody = FINBody
          }
        }

        const reqBody = unflatten(this.unflattenBody)
        const response = await CommonService.validateLocalPaymentTransfer(reqBody)
        if (response && !response.causes && response.document) {
          if (response.document.cstmrPmtStsRpt.orgnlPmtInfAndSts[0].txInfAndSts[0].charges) {
            this.charges = response.document.cstmrPmtStsRpt.orgnlPmtInfAndSts[0].txInfAndSts[0].charges
          }
          this.nextValidate()
        } else {
          this.failureResponseAPI = response?.causes ? response.causes : ''
          this.handleErrors(this.failureResponseAPI)
        }
      } catch (e) {
        console.log(e)
      }
    },
    setTypeValues ({ validationType, primaryDataType }) {
      if (validationType && primaryDataType) {
        if (this.textValidationType.includes(validationType) && this.textPrimaryDataType.includes(primaryDataType.toLowerCase())) {
          return 'text'
        }
        if (this.selectValidationType.includes(validationType.toLowerCase()) && this.selectPrimaryDataType.includes(primaryDataType.toLowerCase())) {
          return 'autocomplete'
        }
        if (this.calendarPrimaryDataType.includes(primaryDataType.toLowerCase())) {
          return 'calendar'
        }
      } else return 'text'
    },
    setRules ({ mandatoryFlag, validationType, validation }) {
      const rules = []
      if (mandatoryFlag === 'true') {
        rules.push('required')
      }
      if (validationType === 'maxLength') {
        rules.push(`maxLenAllowNull(${validation}, ${validation})`)
      }
      return rules
    },
    async mapPaymentForm () {
      this.showForm = true
      this.schema.domesticPayment = {}

      let form = {}
      form = await CommonService.getFormData(`LocalPayments-${this.$i18n.locale}`)
      const { schema, model } = form
      const template = this.route.details
      if (template && !template.causes) {
        template.forEach(item => {
          if (item.include) {
            this.$set(schema, item.fieldName, this.getBaseProperties(item))
            this.mapSchemaRegex(schema, item)
            this.mapSchemaItems(schema, schema[item.fieldName].type, item)
            this.$set(model, item.fieldName, '')
          }
        })
      }
      this.schema.domesticPayment = getFormConfig(form)
      this.schema.domesticPayment.schema.amount.rules = this.schema.domesticPayment.schema.amount.rules.concat([
        this.rules.isAmountNumber,
        this.rules.amountCheck
      ])
      this.setDefaultValues()
    },
    checkForAPIErrors () {
      if (this.$route.meta.paymentError) {
        this.handleErrors(this.$route.meta.paymentError)
      }
    },
    mapSchemaRegex (schema, { validationType, typeName, fieldName, validation }) {
      if (validationType === 'pattern' && typeName === 'regex') {
        schema[`${fieldName}`].regex = validation
      }
    },
    mapSchemaItems (schema, type, { validation, fieldName }) {
      if (type === 'autocomplete') {
        const selectValues = validation.split(',')
        const items = selectValues.map(val => ({
          text: val,
          value: val
        }))
        schema[fieldName].items = [...items]
      }
    },
    getBaseProperties (item) {
      return {
        type: this.setTypeValues(item),
        label: item.labelName,
        color: this.primaryColor,
        class: 'transferFunds--custom-textfield px-2 pt-3',
        filled: true,
        dense: true,
        'background-color': INPUT_BG_COLOR,
        flex: { xs: 12, sm: 12, md: 6, lg: 6, xl: 6 },
        jsonPath: item.jsonPath,
        rules: this.setRules(item),
        hidden: false
      }
    },
    setDefaultValues () {
      const { model, schema } = this.schema.domesticPayment
      Object.keys(model).forEach(key => {
        if (!schema[key]?.default || schema[key].type !== 'calendar') {
          model[key] = ''
          return
        }
        model[key] = schema[key].default === 'today' ? getToday(schema[key].format) : schema[key].default
      })

      model.currency = this.route.currency
    },
    isAnyInputsFilled () {
      const { model } = this.schema.domesticPayment
      return Object.values(model).some(value => value !== null && value !== undefined && value !== '')
    },
    proceedLeave () {
      this.isLeavingRoute = false
      this.$router.push(this.to)
      this.to = ''
    },
    cancelLeave () {
      this.isLeavingRoute = false
      this.to = null
    },
    handleSelectedPayee (selectedPayee) {
      this.toggleDrawer()
      this.accIdentification = selectedPayee.accountIdentification
      this.accBICCode = selectedPayee.bankIdentifier
      this.accIdType = selectedPayee.accountIdentificationType
      this.beneName = selectedPayee.beneficiaryName
      this.beneId = this.formatSelectedPayee(this.accIdType,
        this.accIdentification, this.accBICCode
      )
      event.$emit('setSelectedPayee', this.beneName, this.beneId)
      this.toAccountHasVal = true
    },
    formatSelectedPayee (accountFormat, accountId, bankId) {
      if (accountFormat === 'IBAN') {
        return accountId + ' | ' + bankId
      } else return accountId
    },
    toggleDrawer () {
      // this.openPayee = !this.openPayee
      if (!this.enablePayeeForm) {
        this.openPayee = !this.openPayee
      } else {
        // clears all fields
        if (this.$refs.payeeForm) {
          this.$refs.payeeForm.reset()
        }
        this.enablePayeeForm = false
      }
    },
    onOtpModalClose () {
      this.beneficiaryOtpConfig.enabled = false
      this.showOTPScreen = false
    },
    enableListener () {
      event.$on('IS_OTP_VALID', (val) => {
        if (val && this.enableOTPForAddPayee && this.showOTPScreen) {
          this.beneficiaryOtpConfig.enabled = false
          this.createBene()
        } else {
          this.beneficiaryOtpConfig.enableSave = true
        }
      })
    }
  },
  created () {
    this.getGenericCodes()
    this.bankIdType = this.route.bankIdentifier
    event.$on('togglePayee', () => {
      this.getPayeeList()
      this.openPayee = !this.openPayee
    })
    event.$on('fromAccChange', (fromAcc) => {
      this.fromAccHasVal = true
      this.fromAccDetails = fromAcc
      this.fromAccVal = fromAcc.value
    })
    event.$on('localPaymentTransferComplete', (arg) => {
      this.transactionComplete = arg
      this.isLeavingRoute = !arg
    })
    event.$on('IS_REVIEW_CLEAR', ({ type }) => {
      const date = this.schema.domesticPayment.model.transactionDate
      this.schema.domesticPayment.model.transactionDate = date.split('-').reverse().join('-')
      this.reviewScreen = false
      if (type === 'GoBack') { this.setAccFields = true }
      if (type === 'Reset') {
        this.setAccFields = false
        this.toAccountHasVal = false
        this.fromAccHasVal = false
        this.showForm = false
        setTimeout(() => {
          this.resetFormFields()
        }, 100)
      }
    })
    event.$on('depositPristineLogout', (arg) => {
      this.isLogout = arg
    })
    event.$on('isValid', (valid) => {
      this.reviewButton.disabled = !valid
    })

    this.customerId = JSON.parse(sessionStorage.getItem('username'))
  },
  watch: {
    showOTPScreen () {
      if (this.enableOTPForAddPayee && this.showOTPScreen) {
        setTimeout(() => {
          event.$emit('SEND_OTP', true)
        }, 200)
      }
    }
  },
  beforeRouteLeave (to, from, next) {
    if (this.transactionComplete || !this.isAnyInputsFilled()) {
      this.showForm = false
      this.openPayee = false
      next()
      return
    }

    if (this.to) {
      this.showForm = false
      this.openPayee = false
      next()
      return
    }

    if (this.isLogout) {
      this.to = to
      this.isLeavingRoute = false
      this.$router.push('/login')
      return
    }

    this.to = to
    this.isLeavingRoute = true
  },
  updated () {
    if (this.setAccFields) {
      event.$emit('setSelectedPayee', this.beneName, this.beneId)
      event.$emit('setSelectedDbtr', this.fromAccDetails)
      this.setAccFields = false
    }
    this.enableListener()
  },
  beforeRouteEnter (to, from, next) {
    next(async vm => {
      vm.checkForAPIErrors()
      vm.enableListener()
      await vm.mapPaymentForm()
      vm.getSourceAccountList()
      vm.getPayeeList()
      next()
    })
  }
}
</script>

<style lang="scss" scoped>
.breadcrumb {
  width: 100%;
  padding:0 1%;
  & a {
    text-decoration: none;
    color: #414141;
  }
}
</style>
